import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import AspectRatio from 'components/AspectRatio';
import { Small, MediumUp } from 'components/MediaQuery';
import VideoPlayer from 'components/VideoPlayer';

const ASPECT_RATIO = {
  width: 1920,
  height: 1080,
};

const ArticlePagePromoHeroBackgroundVideo = ({ video, paused }) => {
  const landscapeVideo = get(video, 'landscape');
  const portraitVideo = get(video, 'portrait');

  return (
    <div className="ArticlePagePromoHero__background-video">
      <AspectRatio {...ASPECT_RATIO}>
        <Small>
          <VideoPlayer url={get(portraitVideo, 'src')} playing={!paused} muted loop playsinline />
        </Small>
        <MediumUp>
          <VideoPlayer url={get(landscapeVideo, 'src')} playing={!paused} muted loop playsinline />
        </MediumUp>
      </AspectRatio>
      <style jsx>
        {`
          .ArticlePagePromoHero__background-video {
            width: 100%;
            height: 100%;
            order: 1;
          }
        `}
      </style>
      <style jsx global>
        {`
          .ArticlePagePromoHero__background-video .VideoPlayer {
            padding-top: 0;
            width: 100%;
            height: 100%;
          }

          .ArticlePagePromoHero__background-video .VideoPlayer__player > video {
            object-fit: cover;
          }
        `}
      </style>
    </div>
  );
};

const assetPropType = PropTypes.shape({ src: PropTypes.string.isRequired, alt: PropTypes.string });

ArticlePagePromoHeroBackgroundVideo.propTypes = {
  video: PropTypes.shape({
    landscape: assetPropType.isRequired,
    portrait: assetPropType.isRequired,
  }).isRequired,
  paused: PropTypes.bool,
};

ArticlePagePromoHeroBackgroundVideo.defaultProps = {
  paused: false,
};

export default ArticlePagePromoHeroBackgroundVideo;
